<app-stages [stages]="stages" currentStage="Umieszczenie reklamy">
</app-stages>
<br>
@if (!pending() && !loading()) {
  @if (roadOccupations().length) {
    <app-accordion-group>
      @for (occupation of roadOccupations(); track $index) {
        <app-accordion-item [disabled]="showItemForm" [name]="'Zajęcie nr ' + ($index + 1)">
          <app-ad-placement-occupation-preview [occupation]="occupation">
          </app-ad-placement-occupation-preview>
          <span slot='action'>
                <button
                  (click)='onEditOccupation($event, $index)'
                  class='btn btn-secondary icon-btn'
                  title='Edytuj'
                  [disabled]='showItemForm'>
                  <i class='fa fa-pencil-alt'></i>
                </button>
                &nbsp;
                <button
                  type='button'
                  class='btn btn-red-secondary icon-btn'
                  title='Usuń z listy'
                  [disabled]='showItemForm'
                  (click)='onRemoveOccupation($index, $event)'>
                  <i class='fa fa-trash-alt'></i>
                </button>
              </span>
        </app-accordion-item>
      }
    </app-accordion-group>
  } @else {
    <app-alert alertTitle="Brak dodanych zajęć!" [closable]="false"></app-alert>
  }
  @if (showItemForm) {
    <div class='gov-card'>
      <div class="gov-card__header">
        Dodanie zajęcia
      </div>
      <div class='gov-card__body'>
        <app-ad-placement-road-occupation-form
          [showCancel]="true"
          [edit]='currentIndex !== undefined'
          [form]='form'
          (onCancel)='showItemForm = false'
          (onSubmit)='onUpdateOccupations($event)'>
        </app-ad-placement-road-occupation-form>
      </div>
    </div>
  } @else {
    <br>
    <div class='d-flex justify-content-end'>
      <button type='button' class='btn btn-primary' (click)='onAddOccupation()'>
        {{ roadOccupations().length ? "Dodaj kolejne zajęcie" : "Dodaj zajęcie" }}
      </button>
    </div>
    <br>
  }
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending() || showItemForm"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
